import { TableActionsWrapper } from '@components'

import React, { ReactElement } from 'react'

import { AccountPeriodSelector } from '../AccountPeriodSelector'
import { AccountTableSearch } from '../AccountTableSearch'
import { AccountTableTitle } from '../AccountTableTitle'
import { AccountVoidedFilter } from '../AccountVoidedFilter'

export const AccountTableActions = (): ReactElement => {
  return (
    <TableActionsWrapper>
      <AccountTableTitle />
      <AccountTableSearch />
      <AccountVoidedFilter />
      <AccountPeriodSelector />
    </TableActionsWrapper>
  )
}
